import { render, staticRenderFns } from "./BusinessUnitSidebar.vue?vue&type=template&id=115012fd"
import script from "./BusinessUnitSidebar.vue?vue&type=script&lang=js"
export * from "./BusinessUnitSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports